import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NotebookBackground from "../../img/NotebookBackground"; // Nowy import

import appkaGif from '../../img/apka_gif.gif';
import pobierzImage from '../../img/pobierz.png'; // Import obrazka dla przycisku na dole
import logo from '../../img/logo_full.png'; // 1. Importujemy nowe logo


// Importy Swipera
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import naszego nowego hooka PWA
import { usePwaInstall } from '../../hooks/usePwaInstall';

const PhoneMockup = ({ src, alt, className = "" }) => (
  <div className={`relative mx-auto border-gray-900 bg-gray-900 border-[8px] md:border-[10px] rounded-[2rem] shadow-xl overflow-hidden max-w-[280px] md:max-w-[300px] ${className}`}>
    {/* Notch (Wcięcie na kamerę) */}
    {/* <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/3 h-5 bg-gray-900 rounded-b-xl z-20"></div>
     */}
    {/* Ekran */}
    <div className="h-full w-full bg-white rounded-[1.5rem] overflow-hidden relative z-10">
      <img src={src} className="w-full h-full object-cover" alt={alt} />
    </div>
  </div>
);


const Start1 = () => {

  const { isInstallable, handleInstallClick } = usePwaInstall();
    const clipPathStyle = {
        clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'
    };
        const handleScrollToCta = () => {
        const ctaSection = document.getElementById('cta-section');
        if (ctaSection) {
            ctaSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    const [openFaqIndex, setOpenFaqIndex] = useState(null);

    const features = [
        {
            title: "Personalizowane zadania.",
            description: "Dopasowujemy zadania do twojego poziomu, na bieżąco monitorując twoje postępy.",
            icon: (
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                    </svg>
                </div>
            )
        },
        {
            title: "Tylko zadania maturalne.",
            description: "Nasze zadania zostały stworzone na podstawie oficjalnych arkuszy maturalnych CKE, dzięki czemu masz pewność, że uczysz się właściwych rzeczy.",
icon: (
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                    {/* Poprawiona ikona - arkusz z długopisem */}
                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                </div>
            )
        },
        {
            title: "Integracja z Kartą Wzorów CKE.",
            description: "Każde zadanie zawiera odwołania do oficjalnej Karty Wzorów CKE, co uczy efektywnego korzystania z niej podczas egzaminu.",
            icon: (
                 <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25v2.25A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z" />
                    </svg>
                </div>
            )
        },
        {
            title: "Orzeł AI.",
            description: "Nasz asystent AI zapewnia natychmiastowe wyjaśnienia i rozwiązania krok po kroku, eliminując bariery w nauce.",
            icon: (
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                         <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" />
                    </svg>
                </div>
            )
        }
    ];

     const faqData = [
        {
            question: "Ile to kosztuje?",
            answer: "Aplikacja obecnie znajduje się w otwartej becie do końca grudnia 2025 i do tego czasu jest w pełni darmowa. Wszyscy, którzy zarejestrują się do końca grudnia 2025 i wypełnią ankietę otrzymają pełny dostęp aż do końca maja 2026."
        },
        {
            question: "Czy przy rejestracji trzeba podać kartę kredytową?",
            answer: "Nie, nie trzeba."
        },
        {
            question: "Dlaczego tylko matura podstawowa?",
            answer: "Matura podstawowa obejmuje duży zakres materiału, ale jest on jasno określony. Zadania z roku na rok się powtarzają, są jednak dosyć schematyczne - wystarczy przerobić dużo podobnych zadań i nauczyć się korzystać z Karty Wzorów, żeby zrozumieć metody rozwiązania - i bez problemu zdać maturę."
        },
        {
            question: "Dlaczego system ratingowy jest lepszy od zwyczajnego zbioru zadań?",
            answer: "Badania naukowe pokazały, że uczymy się najbardziej efektywnie wtedy, kiedy zadanie jest wymagające, ale możliwe do zrobienia. Między innymi właśnie to chcemy osiągnąć w AppGradeMath. Nasz algorytm dobiera spersonalizowane zadania na podstawie aktualnych umiejętności, mierzonych naszym systemem ratingowym."
        },
        {
            question: "Czy wasz asystent AI naprawdę umie rozwiązywać i tłumaczyć zadania?",
            answer: "Tak, i to bardzo dobrze! Sami jesteśmy lekko zaskoczeni, jak dokładnie i szczegółowo wyjaśnia rozwiązanie. Podczas testów nie zdarzyło nam się ani razu, żeby rozwiązanie podane przez asystenta było nieprawidłowe."
        }
    ];

    // Funkcja do przełączania otwartego pytania
    const handleFaqToggle = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    const bentoItems = [
        {
            title: "Wsparcie AI",
            description: (
                <>Dzięki zaawansowanej sztucznej inteligencji stworzyliśmy bazę <span className="text-blue-600 font-semibold">ponad 2000 unikatowych</span> zadań typu maturalnego.</>
            )
        },
        {
            title: "Oparte na materiałach CKE",
            description: (
                <>Każde zadanie jest <span className="text-blue-600 font-semibold">ściśle powiązane</span> z zadaniami z arkuszy i informatorów Centralnej Komisji Egzaminacyjnej.</>
            )
        },
        {
            title: "Punktacja maturalna",
            description: (
                <>Zadania posiadają przypisaną punktację, odzwierciedlającą <span className="text-blue-600 font-semibold">system oceniania</span> na maturze.</>
            )
        },
        {
            title: "Weryfikacja przez ekspertów",
            description: (
                <>Każde zadanie zostało sprawdzone przez doświadczonych korepetytorów, gwarantując <span className="text-blue-600 font-semibold">najwyższą jakość</span>.</>
            )
        }
      ];

    return (
        <div className="relative min-h-screen w-full overflow-hidden">
            {/* ================= NOWY PASEK NAWIGACYJNY ================= */}
            <nav className="fixed top-0 left-0 right-0 bg-blue-950/80 backdrop-blur-sm z-50 shadow-md">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        {/* Lewa strona - Logo i Nazwa */}
                        <Link to="/start1" className="flex items-center gap-x-3">
                            <img src={logo} alt="AppGradeMath Logo" className="h-8 w-auto" />
                            <span className="text-l font-semibold text-white sm:block">
                                AppGradeMath
                            </span>
                        </Link>
                        
                        {/* Prawa strona - Przycisk "Zaczynajmy!" */}
                        <button 
                            onClick={handleScrollToCta}
                            className="rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                        >
                            Zaczynajmy!
                        </button>
                    </div>
                </div>
            </nav>
            {/* ================= KONIEC PASKA NAWIGACYJNEGO ================= */}


 {/* ================= ZMIANA TŁA ================= */}
            {/* Stary div z tłem został zastąpiony przez komponent NotebookBackground */}
            <NotebookBackground />


            <div className="relative isolate overflow-hidden bg-blue-950 py-24 sm:py-32">
                <div className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl" aria-hidden="true">
                    <div className="aspect-1097/845 w-274.25 bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20" style={clipPathStyle}></div>
                </div>
                <div className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu" aria-hidden="true">
                    <div className="aspect-1097/845 w-274.25 bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20" style={clipPathStyle}></div>
                </div>
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl lg:mx-0">
                        <h2 className="text-5xl font-semibold tracking-tight text-white sm:text-7xl">AppGradeMath</h2>
                        <p className="mt-8 text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">Innowacyjne rozwiązanie, które pomoże Ci zdać maturę podstawową z matematyki.</p>
                    </div>
                    <div className="mx-auto mt-10 max-w-2xl lg:mx-0 lg:max-w-none">
                        <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
                            <div className="flex flex-col-reverse gap-1">
                                <dt className="text-base/7 text-gray-300">Przykładów z rozwiązaniami</dt>
                                <dd className="text-4xl font-semibold tracking-tight text-white">Ponad 2000</dd>
                            </div>
                            <div className="flex flex-col-reverse gap-1">
                                <dt className="text-base/7 text-gray-300">Twój osobisty nauczyciel</dt>
                                <dd className="text-4xl font-semibold tracking-tight text-white">Orzeł AI</dd>
                            </div>
                            <div className="flex flex-col-reverse gap-1">
                                <dt className="text-base/7 text-gray-300">Zadania dostosowane do umiejętności</dt>
                                <dd className="text-4xl font-semibold tracking-tight text-white">Live Rating</dd>
                            </div>
                            <div className="flex flex-col-reverse gap-1">
                                <dt className="text-base/7 text-gray-300">Tylko. I wyłącznie.</dt>
                                <dd className="text-4xl font-semibold tracking-tight text-white">Zadania maturalne</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>


            {/* ================= SEKCJA "SKROJONA NA MIARĘ" - ZMIENIONA ================= */}
            <div className="relative py-6 sm:py-8 px-8 overflow-hidden">
                <div className="bg-white px-4 py-4 pb-8 shadow-lg ring-1 ring-gray-900/5 w-full sm:max-w-2xl md:max-w-4xl lg:max-w-6xl xl:max-w-7xl sm:mx-auto rounded-lg my-8 lg:my-12">
                    <div className="flex min-h-full flex-col justify-center px-6 py-8 lg:px-12">

                        <div className="text-start">
                            <h2 className="text-base/7 font-semibold text-blue-600">Prawdziwie spersonalizowana nauka</h2>
                            <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl">Skrojona na miarę</p>
                        </div>

                        {/* Nowy kontener na dwie kolumny dla dużych ekranów */}
                        <div className="mx-auto mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            
                            {/* Lewa kolumna: Opis + lista funkcji (tylko na dużych ekranach) */}
                            <div className="hidden lg:block">
                                <p className="text-lg/8 text-gray-600">
                                    AppGradeMath to innowacyjna platforma, z którą rozwijasz swoje umiejętności krok po kroku. A my wspieramy cię w każdym z tych kroków.
                                </p>
                                <dl className="mt-10 max-w-xl space-y-10 text-base/7 text-gray-600">
                                    {features.map((feature) => (
                                        <div key={feature.title} className="relative flex items-start gap-x-4">
                                            <div className="flex-shrink-0">{feature.icon}</div>
                                            <div>
                                                <dt className="inline font-semibold text-gray-900">{feature.title}</dt>
                                                {' '}
                                                <dd className="inline">{feature.description}</dd>
                                            </div>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                            
                            {/* Prawa kolumna (na dużych ekranach) LUB treść dla małych ekranów */}
                            <div>
                                {/* Paragraf widoczny tylko na małych ekranach */}
                                <p className="text-lg/8 text-gray-600 lg:hidden">
                                    AppGradeMath to innowacyjna platforma, z którą rozwijasz swoje umiejętności krok po kroku. A my wspieramy cię w każdym z tych kroków.
                                </p>
                                
                                {/* GIF - teraz jest w tej samej kolumnie, co tekst na małych ekranach */}
                                          <div className="relative mb-12">
                                                {/* Efekt poświaty pod telefonem - to ukrywa niedoskonałości GIFa i robi efekt WOW */}
                                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full  blur-[60px] rounded-full -z-10"></div>
                                                
                                                {/* PHONE MOCKUP z GIFem */}
                                                <PhoneMockup src={appkaGif} alt="Animacja działania aplikacji" className="shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)]" />
                                            </div>
                            </div>

                            {/* Lista funkcji - widoczna tylko na małych ekranach, pod GIF-em */}
                            <div className="lg:hidden">
                                <dl className="mt-10 max-w-xl space-y-10 text-base/7 text-gray-600">
                                    {features.map((feature) => (
                                        <div key={feature.title} className="relative flex items-start gap-x-4">
                                            <div className="flex-shrink-0">{feature.icon}</div>
                                            <div>
                                                <dt className="inline font-semibold text-gray-900">{feature.title}</dt>
                                                {' '}
                                                <dd className="inline">{feature.description}</dd>
                                            </div>
                                        </div>
                                    ))}
                                </dl>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* ================= KONIEC SEKCJI "SKROJONA NA MIARĘ" ================= */}


            {/* ================= SEKCJA Z KARUZELĄ - ZMIENIONA ================= */}
            <div className="relative py-6 sm:py-8 px-8">
                <div className="bg-white px-4 py-4 pb-8 shadow-lg ring-1 ring-gray-900/5 w-full sm:max-w-2xl md:max-w-4xl lg:max-w-6xl xl:max-w-7xl sm:mx-auto rounded-lg my-8 lg:my-12">
                    <div className="flex min-h-full flex-col justify-center px-6 py-8 lg:px-12">
                        <h2 className="text-center text-base/7 font-semibold text-blue-600">Nasza Baza Zadań</h2>
                        <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">Każdy przykład się liczy</p>
                        <p className="mt-6 text-lg/8 text-gray-600">Na potrzeby AppGradeMath stworzyliśmy rozbudowaną bazę przykładów z rozwiązaniami. Aby zawsze było coś nowego do nauki.</p>

                        {/* Kontener dla Swipera i kontrolek */}
                        <div className="mt-16 w-full">
                             {/* Nowy kontener 'relative' tylko dla Swipera i strzałek */}
                            <div className="relative">
                                <Swiper
                                    modules={[Autoplay, Navigation, Pagination]}
                                    loop={true}
                                    autoplay={{ delay: 3000, disableOnInteraction: true }}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    breakpoints={{ 768: { slidesPerView: 2 } }}
                                    navigation={{
                                        nextEl: '.swiper-button-next-custom',
                                        prevEl: '.swiper-button-prev-custom',
                                    }}
                                    pagination={{
                                        el: '.swiper-pagination-custom',
                                        clickable: true,
                                    }}
                                    style={{
                                        '--swiper-navigation-color': '#007aff',
                                        '--swiper-pagination-color': '#007aff',
                                    }}
                                >
                                    {bentoItems.map((item, index) => (
                                        <SwiperSlide key={index} className="self-stretch py-4">
                                            <div className="relative bento-grid-item-container h-full">
                                                <div className="absolute inset-px rounded-3xl bg-white"></div>
                                                <div className="relative flex h-full flex-col overflow-hidden rounded-3xl p-8">
                                                    <p className="text-lg font-medium tracking-tight text-gray-950">{item.title}</p>
                                                    <p className="mt-2 text-sm/6 text-gray-600">
                                                        {item.description}
                                                    </p>
                                                </div>
                                                <div className="pointer-events-none absolute inset-px rounded-3xl shadow-sm ring-1 ring-black/5"></div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                                {/* Zewnętrzne strzałki (pozostają pozycjonowane absolutnie) */}
                                <div className="swiper-button-prev-custom group absolute top-[40%] -left-4 z-10 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white shadow-md transition-transform sm:-left-5">
                                    <svg className="h-6 w-6 text-blue-600 transition-transform group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>
                                </div>
                                <div className="swiper-button-next-custom group absolute top-[40%] -right-4 z-10 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-white shadow-md transition-transform  sm:-right-5">
                                    <svg className="h-6 w-6 text-blue-600 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>
                                </div>
                            </div>
                            
                            {/* POPRAWKA: Kontener na kropki jest TERAZ TUTAJ - w normalnym przepływie, POD karuzelą */}
                            <div className="swiper-pagination-custom w-full text-center"></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ================= KONIEC SEKCJI Z KARUZELĄ ================= */}

 {/* Sekcja "Zappgrade'uj swoją matematykę!" */}
            <div id="cta-section" className="relative py-6 sm:py-8 px-8">
                <div className="bg-white px-4 py-4 shadow-lg ring-1 ring-gray-900/5 w-full sm:max-w-2xl md:max-w-4xl overflow-hidden lg:max-w-6xl xl:max-w-7xl sm:mx-auto rounded-lg my-8 lg:my-12">
                    <div className="flex min-h-full flex-col justify-center px-6 py-8 lg:px-12">

                        {/* ================= ZMIANA ZACZYNA SIĘ TUTAJ ================= */}
                        <h2 className="text-base/7 font-semibold text-blue-600 text-center">Już dziś</h2>
                        
                        <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl text-center">Zappgrade'uj swoją matematykę!</h2>
                        
                        {/* POPRAWKA: Usunięto klasy `max-w-3xl` i `mx-auto` z tego paragrafu */}
                        <p className="mt-6 text-lg/8 text-gray-600">
                            Odkryj nowy wymiar nauki, dopasowanej do Twoich potrzeb i umiejętności. Z AppGradeMath możesz korzystać zarówno w formie aplikacji, jak i z wykorzystaniem przeglądarki!
                        </p>

                        <div className="mt-10 flex flex-col items-center gap-y-6">
                            <div className="flex items-center justify-center gap-x-6">
                                {isInstallable && (
                                    <button
                                        onClick={handleInstallClick}
                                        className="transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 rounded-lg"
                                        title="Zainstaluj Aplikację"
                                    >
                                        <img src={pobierzImage} alt="Pobierz Aplikację" className="h-11 w-auto" />
                                    </button>
                                )}
                                <Link to="/register" className="rounded-md bg-blue-600 px-3.5 py-2.5 text-m font-semibold text-white shadow-xs hover:bg-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">Rejestracja</Link>
                            </div>

                            <p className="text-lg text-gray-400">
                                Masz już konto?{' '}
                                <Link to="/login" className="font-semibold text-blue-600 hover:text-blue-500 hover:underline">
                                    Zaloguj się
                                </Link>
                            </p>
                        </div>
                         {/* =================== ZMIANA KOŃCZY SIĘ TUTAJ =================== */}

                    </div>
                </div>
            </div>
      

   



             <div className="relative py-6 sm:py-8 px-8 overflow-hidden">
                <div className="bg-white px-4 py-4 pb-8 shadow-lg ring-1 ring-gray-900/5 w-full sm:max-w-2xl md:max-w-4xl lg:max-w-6xl xl:max-w-7xl sm:mx-auto rounded-lg my-8 lg:my-12">
                    <div className="flex min-h-full flex-col justify-center px-6 py-8 lg:px-12">
                        
                        {/* Krok 1: Usuwamy klasy centrujące z nagłówków */}
                        <h2 className="text-base/7 font-semibold text-blue-600">Najczęściej zadawane pytania</h2>
                        <p className="mt-2 text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">Dowiedz się więcej</p>
                        
                        <p className="mt-6 text-lg/8 text-gray-600">
                            Tutaj rozwiejesz swoje wątpliwości i dowiesz się więcej. Aby w pełni wykorzystać potencjał naszej aplikacji.
                        </p>
                        
                        {/* Krok 2: Usuwamy klasy centrujące z kontenera listy */}
                        <div className="mt-12 w-full">
                            <dl className="space-y-4">
                                {faqData.map((faq, index) => (
                                    <div key={index} className="border-b border-gray-200 pb-4">
                                        <dt>
                                            <button onClick={() => handleFaqToggle(index)} className="flex w-full items-center justify-between text-left text-gray-900">
                                                <span className="text-base/7 font-semibold">{faq.question}</span>
                                                <span className="ml-6 flex h-7 items-center">
                                                    {openFaqIndex === index ? (
                                                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
                                                        </svg>
                                                    ) : (
                                                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                                                        </svg>
                                                    )}
                                                </span>
                                            </button>
                                        </dt>
                                        <dd className={`overflow-hidden transition-all duration-500 ease-in-out ${openFaqIndex === index ? 'max-h-96 mt-4' : 'max-h-0'}`}>
                                            <p className="text-base/7 text-gray-600">{faq.answer}</p>
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
            {/* ================= KONIEC SEKCJI FAQ ================= */}

            
        </div>
    );
};

export default Start1;